module.exports = __webpack_public_path__ + "img/manager-lic.194c7c02.svg";